import { DropdownMenu } from '@octopus-do/octopus-storybook'
import type React from 'react'

import { formatHour24, HOURS } from '../../utils'
import { SelectTrigger } from '../SelectTrigger'
import css from './styles.module.scss'

interface Props {
  onChange: (hour: number) => void
  value: number
}

interface OptionsProps {
  value: number
}

// The hour list is single-choice, so the design marks the one that is set by
// highlighting its row rather than by putting a tick on it.
const HourOptions: React.FC<OptionsProps> = ({ value }) => (
  <div className={css.menu}>
    {HOURS.map((hour) => (
      <DropdownMenu.Button
        active={hour === value}
        id={String(hour)}
        key={hour}
        title={formatHour24(hour)}
      />
    ))}
  </div>
)

export const HourSelect: React.FC<Props> = ({ onChange, value }) => (
  <DropdownMenu.Root
    align="end"
    content={HourOptions}
    onClick={(keys) => onChange(Number(keys[0]))}
    value={value}
  >
    <SelectTrigger label={`At ${formatHour24(value)}`} />
  </DropdownMenu.Root>
)
